<div class="row">
  <ds-alert-modal [config]="modalConfig" (primaryEvent)="agree()" (tertiaryEvent)="close()">
    <div modal-body>
      <div class="scroll-container" data-cy="paperlessTermsAndConditionsModal">
        <ds-billing-terms [partnerData]="termsPartnerData$ | async"> </ds-billing-terms>
      </div>
    </div>
  </ds-alert-modal>
</div>
